import Globals from './Globals'

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes
const STORAGE_KEY = 'expo.heartbeat.clientId';

let intervalId = null;

function getClientId() {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
        id = crypto.randomUUID ? crypto.randomUUID() :
            'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
}

function getClientType() {
    if (Globals.instance().electron) return 'desktop';
    if (Globals.instance().ipad || Globals.instance().ios) return 'ipad_viewer';
    return 'web';
}

function getStatus() {
    if (Globals.instance().presentationMode || Globals.instance().nid) return 'presenting';
    return 'idle';
}

function sendHeartbeat() {
    if (Globals.instance().noInternet) return;

    var apiBase = Globals.instance().adminAPI;
    if (!apiBase) return;

    var userObj = null;
    try { userObj = JSON.parse(localStorage.getItem('user')); } catch(e) {}
    var token = userObj ? userObj.token : null;

    var headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = 'Token ' + token;

    var body = {
        client_id: getClientId(),
        client_type: getClientType(),
        version: Globals.instance().build,
        status: getStatus(),
        narrative_id: Globals.instance().nid || null,
    };

    fetch(apiBase + '/api/core/heartbeat/', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
    }).then(function() {
        console.log('Heartbeat sent');
    }).catch(function(err) {
        console.warn('Heartbeat failed', err);
    });
}

export function startHeartbeat() {
    if (intervalId) return;
    sendHeartbeat();
    intervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
}

export default { startHeartbeat };
